import { render, staticRenderFns } from "./renovation.vue?vue&type=template&id=95899c5a&scoped=true"
import script from "./renovation.vue?vue&type=script&lang=js"
export * from "./renovation.vue?vue&type=script&lang=js"
import style0 from "./renovation.vue?vue&type=style&index=0&id=95899c5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95899c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95899c5a')) {
      api.createRecord('95899c5a', component.options)
    } else {
      api.reload('95899c5a', component.options)
    }
    module.hot.accept("./renovation.vue?vue&type=template&id=95899c5a&scoped=true", function () {
      api.rerender('95899c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/renovation.vue"
export default component.exports